import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { DashboardDataService } from './dashboard-data.service';
import { DashboardKpis } from '../models/dashboard.model';

@Injectable()
export class InMemoryDashboardDataService extends DashboardDataService {
  getKpis(_branchId?: string): Observable<DashboardKpis> {
    return of({
      todayRevenue: 184_500,
      todayTransactions: 37,
      avgBasketSize: 4986,
      lowStockCount: 8,
      expiringCount: 12,
      pendingOnlineOrders: 3
    }).pipe(delay(150));
  }
}
